import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'quartz-routing/react-router';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped module
import StandardSidebarContainer from 'ContentEditorUI/components/StandardSidebarContainer';
// @ts-expect-error Untyped module
import SidebarPanelContainer from 'page-editor-ui/containers/SidebarPanelContainer';
// @ts-expect-error Untyped module
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getAuth } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getShouldShowInstanceEditingMode } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { getActiveSidebarPanel, getSelectedField, getSidebarCategory } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getSelectedRowOrColumn, getSelectedGridLayoutNode, getSelectedModuleInTree, getSelectedModuleName, getSelectedGridLayoutModuleNode } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getHasTheme } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getEditSidebarActiveTab } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
// @ts-expect-error Untyped module
import PatagoniaAddPanel from 'ContentEditorUI/components/sidebar/PatagoniaAddPanel';
// @ts-expect-error Untyped module
import PatagoniaSidebarContentContainer from 'page-editor-ui/containers/PatagoniaSidebarContentContainer';
// @ts-expect-error Untyped module
import PatagoniaToolsMenu from 'page-editor-ui/containers/PatagoniaToolsContainer';
import PatagoniaXrayPanel from 'ContentEditorUI/components/xray/recommendationPanels/PatagoniaXrayPanel';
import ContentManagement from 'ContentEditorUI/components/contentManagement/ContentManagement';
import { SIDEBAR_PANELS, LAYERS_SIDEBAR_WIDTH, EDIT_MODULE_SIDEBAR_WIDTH, TOOLS_MENU_SIDEBAR_WIDTH, OPTIMIZER_SIDEBAR_WIDTH, PUSHY, PAGE_MANAGEMENT_SIDEBAR_WIDTH, FLOATY } from 'ContentEditorUI/lib/sidebar/constants';
// @ts-expect-error Untyped module
import SidebarContentContainer from 'ContentEditorUI/containers/SidebarContainer';
// @ts-expect-error Untyped module
import { getCurrentTab } from 'ContentEditorUI/redux/selectors/universalNavSelectors';
import { getXrayConfig } from 'page-editor-ui/redux/actions/xrayActionsAndConfig';
// @ts-expect-error Untyped module
import { openPatagoniaModulePanelOnModuleId as openPatagoniaModulePanelOnModuleIdAction } from 'ContentEditorUI/redux/actions/inpageActions';
// @ts-expect-error Untyped module
import { setXrayInpageGathererKeys as setXrayInpageGathererKeysAction } from 'ContentEditorUI/redux/actions/xrayActions';
import { clearQueryParam as clearQueryParamAction, replacePage as replacePageRoutingAction
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/routingActions';
// @ts-expect-error Untyped module
import { getRoutingCurrentPage } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
// @ts-expect-error Untyped module
import { getCanMABExperiment } from 'page-editor-ui/redux/selectors/mabExperimentSelectors';
import { getDefaultAddPanelContentWidth } from 'ContentEditorUI/js/utils/sidebarUtil';
// @ts-expect-error Untyped module
import { parseQueryString } from 'ContentEditorUI/utils/routeHelper';
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getCanUseUniversalThemeEditor, getHasAccessToDesignPanel } from 'page-editor-ui/redux/selectors/authSelectors';
// @ts-expect-error Untyped module
import { setActivePatagoniaPanel as setActivePatagoniaPanelAction } from 'ContentEditorUI/redux/actions/panelActions';
import ThemeEditorContainer from 'page-editor-ui/containers/ThemeEditorContainer';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { GaugeIcon } from 'foundations-assets/icons/components/GaugeIcon';
import { HubDBIcon } from 'foundations-assets/icons/components/HubDBIcon';
import { SiteTreeIcon } from 'foundations-assets/icons/components/SiteTreeIcon';
import { StylesIcon } from 'foundations-assets/icons/components/StylesIcon';
import { TestIcon } from 'foundations-assets/icons/components/TestIcon';
import { getHasOpenedUniversalThemeEditorPanel } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncHubDBContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'HubDBFormEditor' */
// @ts-expect-error Untyped module
'ContentEditorUI/containers/hubdb/HubDBFormEditor'));
const AsyncPageDesignSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'PageDesignSidebarContainer' */
// @ts-expect-error Untyped module
'page-editor-ui/containers/PageDesignSidebarContainer'));
const mapStateToProps = state => ({
  activePanel: getActiveSidebarPanel(state),
  editSidebarActiveTab: getEditSidebarActiveTab(state),
  selectedField: getSelectedField(state),
  selectedModuleInTree: getSelectedModuleInTree(state),
  selectedModuleName: getSelectedModuleName(state),
  selectedRowOrColumn: getSelectedRowOrColumn(state),
  selectedGridLayoutNode: getSelectedGridLayoutNode(state),
  selectedGridLayoutModuleNode: getSelectedGridLayoutModuleNode(state),
  hasAnyContainerOrDndAreaToAddModules: getHasAnyContainerOrDndAreaToAddModules(state),
  currentTab: getCurrentTab(state),
  selectedSidebarCategory: getSidebarCategory(state),
  showInlineDataTokenEditing: getShouldShowInstanceEditingMode(state),
  xrayConfigFromEditor: getXrayConfig(getAuth(state)),
  canMABExperiment: getCanMABExperiment(state),
  categorizedSearchQuery: getSidebarSearchQuery(state),
  hasTheme: getHasTheme(state),
  currentRoutingPathname: getRoutingCurrentPage(state),
  canUseUniversalThemeEditor: getCanUseUniversalThemeEditor(state),
  hasOpenedUniversalThemeEditorPanel: getHasOpenedUniversalThemeEditorPanel(state),
  hasAccessToDesignPanel: getHasAccessToDesignPanel(state)
});
const mapDispatchToProps = {
  setXrayInpageGathererKeys: setXrayInpageGathererKeysAction,
  openPatagoniaModulePanelOnModuleId: openPatagoniaModulePanelOnModuleIdAction,
  clearQueryParam: clearQueryParamAction,
  setActivePatagoniaPanel: setActivePatagoniaPanelAction,
  replaceRoutingPathname: replacePageRoutingAction
};
class SidebarContainer extends Component {
  componentDidMount() {
    const {
      xrayConfigFromEditor,
      setXrayInpageGathererKeys,
      location,
      clearQueryParam,
      hasAnyContainerOrDndAreaToAddModules,
      openPatagoniaModulePanelOnModuleId,
      setActivePatagoniaPanel,
      currentRoutingPathname,
      replaceRoutingPathname
    } = this.props;
    setXrayInpageGathererKeys(xrayConfigFromEditor);
    const {
      moduleSchemaId
    } = parseQueryString(location === null || location === void 0 ? void 0 : location.search);
    if (moduleSchemaId) {
      if (hasAnyContainerOrDndAreaToAddModules) {
        openPatagoniaModulePanelOnModuleId(Number(moduleSchemaId));
      }
      clearQueryParam('moduleSchemaId');
    } else if (currentRoutingPathname === 'test') {
      setActivePatagoniaPanel(SIDEBAR_PANELS.tools);
      // Replace `/test` with `/content` so we always end up back on the "main" path ('/content')
      replaceRoutingPathname('content');
    }
  }
  sidebarOptions() {
    const {
      selectedSidebarCategory,
      showInlineDataTokenEditing,
      xrayConfigFromEditor,
      hasAnyContainerOrDndAreaToAddModules,
      canMABExperiment,
      categorizedSearchQuery,
      canUseUniversalThemeEditor,
      hasOpenedUniversalThemeEditorPanel,
      hasAccessToDesignPanel
    } = this.props;
    const tooltipLabel = 'patagonia.sidebar.tooltipLabel';
    const addButtonTooltipKey = !hasAnyContainerOrDndAreaToAddModules ? 'sidebar.tabs.add.disabled.patagoniaMessage' : 'patagonia.sidebar.tooltipLabel.add';
    return [{
      type: 'panel',
      iconName: 'add',
      iconNode: AddIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: addButtonTooltipKey
      }),
      disabled: !hasAnyContainerOrDndAreaToAddModules,
      panelName: SIDEBAR_PANELS.addWidget,
      content: /*#__PURE__*/_jsx(PatagoniaAddPanel, {}),
      contentWidth: getDefaultAddPanelContentWidth(selectedSidebarCategory, !!categorizedSearchQuery),
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'siteTree',
      iconNode: SiteTreeIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageContents`
      }),
      panelName: SIDEBAR_PANELS.pageContents,
      content: /*#__PURE__*/_jsx(PatagoniaSidebarContentContainer, {}),
      contentWidth: LAYERS_SIDEBAR_WIDTH,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'separator'
    }, {
      type: 'panel',
      iconName: 'gauge',
      iconNode: GaugeIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.optimizer`
      }),
      panelName: SIDEBAR_PANELS.optimizer,
      content: /*#__PURE__*/_jsx(PatagoniaXrayPanel, {
        config: xrayConfigFromEditor
      }),
      contentWidth: OPTIMIZER_SIDEBAR_WIDTH,
      hideItem: false,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'test',
      iconNode: TestIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.test`
      }),
      panelName: SIDEBAR_PANELS.tools,
      content: /*#__PURE__*/_jsx(PatagoniaToolsMenu, {}),
      contentWidth: TOOLS_MENU_SIDEBAR_WIDTH,
      hideItem: !canMABExperiment,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'separator'
    }, {
      type: 'panel',
      iconName: 'styles',
      iconNode: StylesIcon,
      tooltipLabel: canUseUniversalThemeEditor ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "sidebar.tabs.universalTheme.title"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "sidebar.tabs.design.title"
      }),
      panelName: SIDEBAR_PANELS.design,
      content: canUseUniversalThemeEditor ? /*#__PURE__*/_jsx(ThemeEditorContainer, {}) : /*#__PURE__*/_jsx(AsyncPageDesignSidebarContainer, {}),
      hideItem: !hasAccessToDesignPanel,
      showBetaBadge: !hasOpenedUniversalThemeEditorPanel && hasAccessToDesignPanel && canUseUniversalThemeEditor,
      contentWidth: EDIT_MODULE_SIDEBAR_WIDTH,
      panelDisplay: {
        type: PUSHY,
        showScroll: true
      }
    }, {
      type: 'panel',
      iconName: 'file',
      iconNode: FileIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageManagement`
      }),
      panelName: SIDEBAR_PANELS.pageManagement,
      content: /*#__PURE__*/_jsx(ContentManagement, {}),
      contentWidth: PAGE_MANAGEMENT_SIDEBAR_WIDTH,
      hideItem: false,
      panelDisplay: {
        type: FLOATY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'edit',
      iconNode: EditIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageContents`
      }),
      panelName: SIDEBAR_PANELS.edit,
      content: this.renderSidebarContainer(),
      contentWidth: EDIT_MODULE_SIDEBAR_WIDTH,
      hideItem: true,
      panelDisplay: {
        type: PUSHY,
        showScroll: true
      }
    }, {
      type: 'instance-editing',
      iconName: 'hubDB',
      iconNode: HubDBIcon,
      tooltipLabel: 'Hub DB Instance Editing',
      panelName: SIDEBAR_PANELS.instanceEditing,
      content: /*#__PURE__*/_jsx(AsyncHubDBContainer, {}),
      hideItem: !showInlineDataTokenEditing,
      contentWidth: 400,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }];
  }
  renderSidebarPanelContainer() {
    const {
      activePanel,
      editSidebarActiveTab,
      selectedField,
      selectedModuleInTree,
      selectedModuleName,
      selectedRowOrColumn,
      selectedGridLayoutNode,
      selectedGridLayoutModuleNode
    } = this.props;
    return /*#__PURE__*/_jsx(SidebarPanelContainer, {
      panelName: activePanel,
      selectedRowOrColumn: selectedRowOrColumn,
      selectedGridLayoutNode: selectedGridLayoutNode,
      selectedGridLayoutModuleNode: selectedGridLayoutModuleNode,
      selectedModuleInTree: selectedModuleInTree,
      selectedModuleName: selectedModuleName,
      editSidebarActiveTab: editSidebarActiveTab,
      selectedField: selectedField,
      showDeviceToggle: true
    });
  }
  renderSidebarContainer() {
    const {
      currentTab,
      showDeviceToggle,
      activePanel,
      editSidebarActiveTab,
      selectedField,
      selectedModuleInTree,
      selectedModuleName,
      selectedRowOrColumn,
      selectedGridLayoutNode,
      selectedGridLayoutModuleNode
    } = this.props;
    return /*#__PURE__*/_jsx(SidebarContentContainer, {
      currentTab: currentTab,
      showDeviceToggle: showDeviceToggle,
      children: /*#__PURE__*/_jsx(SidebarPanelContainer, {
        panelName: activePanel,
        selectedRowOrColumn: selectedRowOrColumn,
        selectedModuleInTree: selectedModuleInTree,
        selectedGridLayoutNode: selectedGridLayoutNode,
        selectedGridLayoutModuleNode: selectedGridLayoutModuleNode,
        selectedModuleName: selectedModuleName,
        editSidebarActiveTab: editSidebarActiveTab,
        selectedField: selectedField,
        showDeviceToggle: true
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsx(StandardSidebarContainer, {
      sidebarOptions: this.sidebarOptions(),
      children: this.renderSidebarPanelContainer()
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SidebarContainer));